/**
 * Multipart file-part port — web implementation.
 *
 * Browsers require a real File/Blob in FormData. Callers should pass the picked
 * File through `blob`; the `uri` fallback fetches an object/blob URL.
 */
export interface FilePartInput {
  /** Local file URI on native, or an object URL / blob URL on web. */
  uri: string;
  name: string;
  type: string;
  /** The picked File/Blob. Preferred over `uri` when present. */
  blob?: Blob | null;
}

export const buildFilePart = ({ blob, name, type }: FilePartInput): Blob => {
  if (!blob) {
    throw new Error(
      'buildFilePart: web uploads require the picked File/Blob. Pass it as `blob`.',
    );
  }
  return new File([blob], name, { type });
};
